export const FIND_SHIPPING_TOLL_VOUCHER = 'FIND_SHIPPING_TOLL_VOUCHER'
export const GET_SHIPPING_TOLL_VOUCHER = 'GET_SHIPPING_TOLL_VOUCHER'
export const IS_LOADING_VOUCHER_DETAILS = 'IS_LOADING_VOUCHER_DETAILS'
export const CHECK_STATUS_LOADING = 'CHECK_STATUS_LOADING'
export const SET_RECEIPT_LOADING = 'SET_RECEIPT_LOADING'
export const SET_ERROR_DETAILS = 'SET_ERROR_DETAILS'
